import { Text } from '../../../../cdl/Text/Text';
import { translate } from '../../../../common/helpers/translate.helper';
import { Box } from '../../../../common/ui/Box';

export const OfferHistoryEmptyState = () => {
    return (
        <Box
            borderStyle="solid"
            borderWidth="1px"
            borderColor="border.muted"
            borderRadius={8}
            padding={24}
            display="flex"
            flexDirection="column"
            gap={8}
            backgroundColor="background.default"
        >
            <Text variant="subtitle1">{translate('offer.history.empty.title')}</Text>
            <Text color="foreground.muted">{translate('offer.history.empty.description')}</Text>
        </Box>
    );
};
